import Routes from './routes';

const generateRoute = (route: string | Routes, data: object, hash?: string) => {
    let output = Object.entries(data).reduce(
        (acc, [key, value]) => acc.replace(`:${key}`, value),
        String(route),
    );

    if (hash) {
        output = `${output}#${hash}`;
    }

    return output;
};

export default generateRoute;
